import { Chance } from "chance"
import { ExtractProduct } from "etl/types";

const chance = new Chance();

export const extractProductFactoryMock = (howMany: number): ExtractProduct[] =>
	Array.from({ length: howMany }).map((_, index) => ({
		"@id": `/api/extract_products/${index + 1}`,
		"@type": "ExtractProduct",
		aw_company_id: chance.integer().toString(),
		aw_company_libelle: chance.word(),
		categorie: chance.word(),
		fournisseur: chance.word(),
		id: index + 1,
		libelle: chance.word(),
		marque: chance.word(),
		hb_id: chance.integer().toString()
	}));
